module.exports = __webpack_public_path__ + "img/125.8c2034a6.jpg";